import RequestBase from '../Resources/RequestBase';

export default class ConnectRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/connect/token';
        this.method = 'POST';
        this.contentType = 'application/x-www-form-urlencoded';
        this.parameters = [
            'client_id',
            'client_secret',
            'grant_type',
            'username',
            'password'
        ];

        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = 'Access Token';
    }

    get body() {
        return 'client_id=' + this.apiId +
               '&client_secret=' + this.apiKey +
               '&grant_type=password&username=' + this.username +
               '&password=' + this.password;
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Connections.js